module.exports = __webpack_public_path__ + "img/applets1icon2.74c8db73.png";